<div class="mat-menu-toolbar header">
  <ui-toolbar></ui-toolbar>
</div>
